import React, { FC, useState } from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EditTenderedActionForm from './edit-tendered-action-form.component';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { updateTenderedActionTemplate } from 'apollo/templates/action';
import { useMutation } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { ActionPrice, TenderedActionProductionTemplate } from 'models/organization';

type EditTenderedActionDialogProps = {
    dialogOpen: boolean;
    customerId: string;
    onCloseDialog: () => void;
    actionToEdit: ActionPrice;
    onEditAction: () => void;
};
const EditTenderedActionDialog: FC<EditTenderedActionDialogProps> = ({
    dialogOpen,
    customerId,
    onCloseDialog,
    actionToEdit,
    onEditAction,
}) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    const [isValid, setIsValid] = useState<boolean>();
    const [tenderedAction, setTenderedAction] = useState<TenderedActionProductionTemplate>();
    const { showBoundary } = useDenthubErrorBoundary();

    const [updateTenderedAction] = useMutation(updateTenderedActionTemplate, {
        onCompleted: ({ updateTenderedAction }) => {
            if (updateTenderedAction) {
                onCloseDialog();
                onEditAction();
            }
        },
        onError: (error) => {
            showBoundary(error);
        },
    });

    const handleProductionChange = (tenderedAction: TenderedActionProductionTemplate, isValid: boolean) => {
        setIsValid(isValid);
        setTenderedAction(tenderedAction);
    };
    const handleSave = async () => {
        await updateTenderedAction({
            variables: {
                customerId,
                actionId: tenderedAction?.actionId,
                internalCode: tenderedAction?.internalCode,
                productionPlanningTemplate: tenderedAction?.productionPlanningTemplate,
                productionValueTemplate: tenderedAction?.productionValueTemplate,
                productionDeductionValue: tenderedAction?.productionDeductionValue,
                materialMacros: tenderedAction?.materialMacros,
            },
        });
    };

    return (
        <DHDialog
            title={translate('orders:EDIT_ACTION')}
            maxWidth="md"
            fullWidth
            open={dialogOpen}
            onClose={onCloseDialog}
            actions={
                <Box>
                    <Button disabled={!isValid} variant="contained" onClick={handleSave}>
                        {translate('common:SAVE')}
                    </Button>
                </Box>
            }
        >
            <EditTenderedActionForm actionToEdit={actionToEdit} onProductionChange={handleProductionChange} />
        </DHDialog>
    );
};

export default EditTenderedActionDialog;
